const getPathname = (ctx: NextPageContext | ServerSidePropsContext): string => {
  if (typeof ctx.asPath === 'string') {
    return ctx.asPath;
  }

  if (typeof ctx.resolvedUrl === 'string') {
    return ctx.resolvedUrl;
  }

  return '';
};

export const patchAppContextUrl = (
  ctx: NextPageContext | ServerSidePropsContext,
): Partial<AppContext> => {
  const { req } = ctx;
  const host = req.get('host') ?? '';
  const baseUrl = `${req.protocol}://${host}/`;
  const pathname = getPathname(ctx);
  const url = new URL(pathname, baseUrl);
  const originalUrl = url.toString();
  return {
    originalUrl,
  };
};
